export function parseDateSafe(value) {
    if (!value) return null;
    if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
    const normalized =
        typeof value === "string" ? value.replace(" ", "T") : value;
    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function getOrderCreatedAt(order) {
    return parseDateSafe(order?.creation || order?.creation_time);
}

export function getOrderLastFoodReadyAt(historyDoc) {
    if (!historyDoc) return null;
    const rawOps = historyDoc?.operations;
    let ops = rawOps;
    if (typeof rawOps === "string") {
        try {
            ops = JSON.parse(rawOps);
        } catch (e) {
            ops = null;
        }
    }
    if (!Array.isArray(ops) || ops.length === 0) {
        return null;
    }
    let last = null;
    for (const op of ops) {
        if (!op || op.type !== "food_ready") continue;
        const t = parseDateSafe(op.time);
        if (!t) continue;
        if (!last || t.getTime() > last.getTime()) {
            last = t;
        }
    }
    return last;
}

export function isOrderLate({
    order,
    lastFoodReadyAt,
    thresholdMinutes,
    enabled,
    nowMs,
}) {
    if (!enabled) return false;
    if (!thresholdMinutes || thresholdMinutes <= 0) return false;
    if (!order || order.food_ready_time) return false;

    const thresholdMs = thresholdMinutes * 60_000;
    const now = typeof nowMs === "number" ? nowMs : Date.now();
    const createdAt = getOrderCreatedAt(order);
    const ref = lastFoodReadyAt || createdAt;
    if (!ref) return false;
    return now - ref.getTime() >= thresholdMs;
}
